var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('layout-report-with-banner', {
    attrs: {
      "showFooter": false,
      "isProgressDone": true
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn() {
        return [_vm.breadCrumbs ? _c('v-breadcrumbs', {
          staticClass: "ml-n2 pt-2",
          attrs: {
            "items": _vm.breadCrumbs
          },
          scopedSlots: _vm._u([{
            key: "divider",
            fn: function fn() {
              return [_c('v-icon', [_vm._v("mdi-chevron-right")])];
            },
            proxy: true
          }], null, false, 3681283568)
        }) : _vm._e(), _c('v-row', {
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-col', {
          attrs: {
            "lg": "4",
            "md": "4",
            "sm": "12"
          }
        }, [_c('pie-chart-card', {
          attrs: {
            "loading": _vm.isLoading,
            "data": _vm.coverageTypeCountData,
            "title": "views.report.fleet.FleetAnalyticsView.coverageTypeCount"
          }
        })], 1), _c('v-col', {
          attrs: {
            "lg": "4",
            "md": "4",
            "sm": "12"
          }
        }, [_c('pie-chart-card', {
          attrs: {
            "loading": _vm.isLoading,
            "data": _vm.damageTypeCountData,
            "title": "views.report.fleet.FleetAnalyticsView.damageTypeCount"
          }
        })], 1), _c('v-col', {
          attrs: {
            "lg": "4",
            "md": "4",
            "sm": "12"
          }
        }, [_c('pie-chart-card', {
          attrs: {
            "loading": _vm.isLoading,
            "data": _vm.tripTypeCountData,
            "title": "views.report.fleet.FleetAnalyticsView.tripTypeCount"
          }
        })], 1), _c('v-col', {
          attrs: {
            "lg": "4",
            "md": "4",
            "sm": "12"
          }
        }, [_c('bar-chart-card', {
          attrs: {
            "loading": _vm.isLoading,
            "data": _vm.statusDistributionData,
            "sort": false,
            "title": "views.report.fleet.FleetAnalyticsView.statusTypeDistribution"
          }
        })], 1), _c('v-col', {
          attrs: {
            "lg": "4",
            "md": "4",
            "sm": "12"
          }
        }, [_c('bar-chart-card', {
          attrs: {
            "loading": _vm.isLoading,
            "data": _vm.weekdayDistributionData,
            "title": "views.report.fleet.FleetAnalyticsView.weekdayDistribution",
            "reverseAxis": true,
            "sort": false
          }
        })], 1)], 1), _c('v-row', {
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-col', {
          attrs: {
            "lg": "4",
            "md": "4",
            "sm": "12"
          }
        }, [_c('pie-chart-card', {
          attrs: {
            "loading": _vm.isLoading,
            "data": _vm.coverageTypeSubtotalData,
            "title": "views.report.fleet.FleetAnalyticsView.coverageTypeSubtotalOutbound"
          }
        })], 1), _c('v-col', {
          attrs: {
            "lg": "4",
            "md": "4",
            "sm": "12"
          }
        }, [_c('pie-chart-card', {
          attrs: {
            "loading": _vm.isLoading,
            "data": _vm.damageTypeSubtotalData,
            "title": "views.report.fleet.FleetAnalyticsView.damageTypeSubtotalOutbound"
          }
        })], 1), _c('v-col', {
          attrs: {
            "lg": "4",
            "md": "4",
            "sm": "12"
          }
        }, [_c('bar-chart-card', {
          attrs: {
            "loading": _vm.isLoading,
            "data": _vm.topCreditorData,
            "title": "views.report.fleet.FleetAnalyticsView.topCreditorDistribution"
          }
        })], 1)], 1)];
      },
      proxy: true
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }